/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PeriodicNotification } from '../models/PeriodicNotification';
import type { PeriodicNotificationCreate } from '../models/PeriodicNotificationCreate';
import type { PeriodicNotificationPatch } from '../models/PeriodicNotificationPatch';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PeriodicNotificationService {
    /**
     * Get Periodic Notifications
     * @param offset
     * @param limit
     * @returns PeriodicNotification Successful Response
     * @throws ApiError
     */
    public static getPeriodicNotificationsPeriodicNotificationGet(
        offset: number,
        limit: number,
    ): CancelablePromise<Array<PeriodicNotification>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/periodic_notification/',
            query: {
                'offset': offset,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Periodic Notification
     * @param requestBody
     * @returns PeriodicNotification Successful Response
     * @throws ApiError
     */
    public static createPeriodicNotificationPeriodicNotificationPost(
        requestBody: PeriodicNotificationCreate,
    ): CancelablePromise<PeriodicNotification> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/periodic_notification/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Periodic Notification
     * @param periodicNotificationId
     * @returns PeriodicNotification Successful Response
     * @throws ApiError
     */
    public static getPeriodicNotificationPeriodicNotificationPeriodicNotificationIdGet(
        periodicNotificationId: number,
    ): CancelablePromise<PeriodicNotification> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/periodic_notification/{periodic_notification_id}',
            path: {
                'periodic_notification_id': periodicNotificationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Periodic Notification
     * @param periodicNotificationId
     * @param requestBody
     * @returns PeriodicNotification Successful Response
     * @throws ApiError
     */
    public static patchPeriodicNotificationPeriodicNotificationPeriodicNotificationIdPatch(
        periodicNotificationId: number,
        requestBody: PeriodicNotificationPatch,
    ): CancelablePromise<PeriodicNotification> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/periodic_notification/{periodic_notification_id}',
            path: {
                'periodic_notification_id': periodicNotificationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Periodic Notification
     * @param periodicNotificationId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deletePeriodicNotificationPeriodicNotificationPeriodicNotificationIdDelete(
        periodicNotificationId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/periodic_notification/{periodic_notification_id}',
            path: {
                'periodic_notification_id': periodicNotificationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
